import Vue from 'vue'
import PortalVue from 'portal-vue'
import App from './App.vue'
import router from './router'
import AOS from 'aos'
import 'aos/dist/aos.css'

Vue.config.productionTip = false

Vue.use(PortalVue)

router.afterEach((to) => {
	Vue.nextTick(() => {
		document.title = to.meta.title ? to.meta.title : 'default title';
	});
})

new Vue({
	router,
	render: h => h(App),
	created() {
		AOS.init()
	}
}).$mount('#app')
